import React from "react";

const SkeletonItem = ({ hasIcon = true, width = "w-32", indent = false }) => (
  <div
    className={`flex items-center gap-3 px-3 py-2.5 ${
      indent ? "pl-9" : ""
    } animate-pulse`}
  >
    {hasIcon && <div className="h-5 w-5 rounded-md bg-white/10" />}
    <div className={`h-4 ${width} rounded bg-white/10`} />
  </div>
);

const SidebarSkeleton = ({ isCollapsed }) => {
  if (isCollapsed) {
    return (
      <div className="space-y-2 p-2">
        {Array.from({ length: 10 }).map((_, i) => (
          <div
            key={i}
            className="mx-auto h-10 w-10 rounded-lg bg-white/10 animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {/* Top Static */}
      <SkeletonItem width="w-28" />

      {/* Dynamic Sections */}
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="space-y-1">
          <SkeletonItem width="w-36" />

          <div className="ml-5 border-l border-white/10 pl-2">
            <SkeletonItem hasIcon={false} indent width="w-28" />
            <SkeletonItem hasIcon={false} indent width="w-24" />
          </div>
        </div>
      ))}

      {/* Bottom Static */}
      <div className="pt-3">
        <SkeletonItem width="w-32" />
        <SkeletonItem width="w-24" />
        <SkeletonItem width="w-28" />
      </div>
    </div>
  );
};

export default SidebarSkeleton;
